var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bradgall"},[_c('div',{staticClass:"flex gap-6 mt-8"},[_c('div',{staticClass:"w-1/2"},[_c('PieChart')],1),_c('div',{staticClass:"w-1/2"},[_c('BarChart')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }